const MS = {
  segments: [
    { start: 0, end: 8, speaker: 1, text: "Assalamualaikum dan selamat pagi semua. Kita mulakan mesyuarat pengurusan projek sistem e-Kehadiran." },
    { start: 8, end: 19, speaker: 2, text: "Status pembangunan sudah 80 peratus siap, cuma integrasi dengan sistem HR masih tertunda." },
    { start: 19, end: 31, speaker: 1, text: "Baik, kita putuskan go-live dianjakkan ke 15 Julai supaya UAT boleh dibuat dengan lengkap." },
    { start: 31, end: 42, speaker: 3, text: "Saya akan sediakan laporan UAT dan hantar kepada pengerusi sebelum Jumaat ini." },
    { start: 42, end: 52, speaker: 2, text: "Isu lesen server belum selesai lagi, perlu kelulusan bahagian kewangan." },
  ],
  names: { 1: "Pengerusi", 2: "Pembicara 2", 3: "Pembicara 3" },
  notes: { content: { decisions: [{ text: "Go-live dianjakkan ke 15 Julai", start: 19 }] } },
  actions: [
    { task: "Sediakan laporan UAT", owner: "Pembicara 3" },
    { task: "Dapatkan kelulusan lesen server", owner: "Tidak dinyatakan" },
  ],
  minutes: `> DRAF — untuk semakan

## Minit Mesyuarat Pengurusan Projek e-Kehadiran
**Bil. Mesyuarat:** [Perlu dilengkapkan] · **Tarikh:** 12 Jun 2026 · **Tempat:** [Perlu dilengkapkan]

## 1. Perkara Berbangkit
- Integrasi dengan sistem HR masih tertunda.

## 2. Keputusan
- Tarikh go-live dianjakkan ke **15 Julai** bagi membolehkan UAT lengkap.

## 3. Tindakan
- Laporan UAT — Pembicara 3 — Jumaat ini
- Kelulusan lesen server — Tidak dinyatakan — Tidak dinyatakan`,
  live: [
    ["Pengerusi", "Assalamualaikum dan selamat pagi semua. Kita mulakan mesyuarat jawatankuasa kali ketiga."],
    ["Setiausaha", "Minit mesyuarat lepas telah diedarkan dan disahkan tanpa pindaan."],
    ["Pengerusi", "Baik, untuk perkara 3.1, sila kemukakan status bajet program Hari Inovasi."],
    ["Bendahari", "Bajet yang diluluskan ialah RM45,000 dan perbelanjaan setakat ini RM31,200."],
    ["Pengerusi", "Tindakan: Unit Kewangan sediakan laporan penuh sebelum 15 Julai."],
  ],
};

const EN = {
  segments: [
    { start: 0, end: 8, speaker: 1, text: "Good morning everyone. Let's begin the project management meeting for the e-Attendance system." },
    { start: 8, end: 19, speaker: 2, text: "Development is 80 percent complete; only the integration with the HR system is still pending." },
    { start: 19, end: 31, speaker: 1, text: "Right, we've decided to move go-live to 15 July so UAT can be completed properly." },
    { start: 31, end: 42, speaker: 3, text: "I'll prepare the UAT report and send it to the chair before this Friday." },
    { start: 42, end: 52, speaker: 2, text: "The server licence issue isn't resolved yet; it needs approval from the finance division." },
  ],
  names: { 1: "Chair", 2: "Speaker 2", 3: "Speaker 3" },
  notes: { content: { decisions: [{ text: "Go-live moved to 15 July", start: 19 }] } },
  actions: [
    { task: "Prepare the UAT report", owner: "Speaker 3" },
    { task: "Obtain server licence approval", owner: "Not stated" },
  ],
  minutes: `> DRAFT — for review

## Minutes of the e-Attendance Project Management Meeting
**Meeting No.:** [To be completed] · **Date:** 12 June 2026 · **Venue:** [To be completed]

## 1. Matters Arising
- Integration with the HR system is still pending.

## 2. Decisions
- Go-live date moved to **15 July** to allow full UAT.

## 3. Actions
- UAT report — Speaker 3 — This Friday
- Server licence approval — Not stated — Not stated`,
  live: [
    ["Chair", "Good morning everyone. Let's begin the third committee meeting."],
    ["Secretary", "The previous minutes were circulated and confirmed without amendments."],
    ["Chair", "Right, for item 3.1, please present the Innovation Day budget status."],
    ["Treasurer", "The approved budget is RM45,000 and spending so far is RM31,200."],
    ["Chair", "Action: the Finance Unit to prepare a full report before 15 July."],
  ],
};

export const getDemo = (lang) => (lang === "en" ? EN : MS);
